import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy, OnInit,
} from "@angular/core";
import {Widget} from "@ispm/widgets/decorator/widget.decorator";
import {IWidgetItem} from "@ispm/widgets/interfaces/widget-item.interface";
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import {ITEMS_TYPES} from "@ispm/dynamic-form/constants/ItemsTypes";
import  { IspmHttpClient } from "@ispm/core/services/ispm-http-client";
import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";
import {Subject} from "rxjs";
import {take} from 'rxjs/operators';
import {FormGroup} from "@angular/forms";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import { NotificationMessageService } from "@ispm/core/components/customise-notification/notifications-message.service";
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import { StringUtils } from "@ispm/shared/utils/String.utils";
import {FileService} from "@ispm-client/modules/file-module/services/file.service";
import { AuthenticationService } from "@ispm/user/services/authentication.service";

@Component({
  selector: 'gen-common-document',
  templateUrl: './common-docs-upload-details-modal.component.html',
  styleUrls: ['./common-docs-upload-details-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

@Widget('CommonDocument')
export class CommonDocumentComponent implements OnInit, OnDestroy, IWidgetItem<any> {

  private _formConfig: Array<any>;

  public widgetData: any;
  public widgetPayload:any;
  public app: any;
  public doc:any;
  private destroyed$: Subject<any> = new Subject();
  private temp:any;
  public inputConfig= [];
  public fileName= "No file chosen";
  private fileTypes = {};
  widgetUpdateValueCallback: (value) => void;
  public listenToDataChange = true;

  constructor(private _ispmHttpClient: IspmHttpClient,
              private _isgHttpClient: HttpInterceptorService,
              private notificationMessageService: NotificationMessageService,
              private _changeDetector: ChangeDetectorRef,
              private _UserActionCreatorService: UserActionCreatorService,
              private notificationMessage: NOTIFICATION_MESSAGE,
              private fileService: FileService,
              private authService: AuthenticationService) {
  }


  public upload(files: File[]){
    if (files && files.length >0) {
      if (this.fileService.isForbiddenFileTypes(files[0].name, this.fileTypes)) {
        return;
      }

      if (StringUtils.isInvalidCharsInFileName(files[0].name)) {
        this.notificationMessageService.error(`${this.notificationMessage.FILENAME_CONTAINS_HTML}`);
        return;
      }
      this.doc = files[0];
      this.fileName = this.doc.name;
      this.widgetUpdateValueCallback(this.doc);
    }
  }

  public submitCommonDocument() {
    let fd = new FormData();
    fd.append('file', this.doc);
    if (this.doc != null && this.app != null) {
      const usr = this.authService.getUser();
      const queryString = "AppId=" + this.app.id + '&actor=' + usr.info.name[0].text + '&role=' + usr.role;
      this._isgHttpClient.post('/reportsAndDocuments/uploadCommonDocument?' + queryString, fd).subscribe(resdata => {
        this.notificationMessageService.success('Document Uploaded Successfully');
        this._UserActionCreatorService.setReloadAdminWorklist(true);
      }, err => {   this.notificationMessageService.error('Unable to Upload Document'); });
    }
  }

  set widgetConfig(widgetConfig) {
    this.widgetPayload = widgetConfig.widgetPayload;
    this._formConfig = this.widgetPayload.formConfig;
    this.inputConfig.push(Object.assign(
      DynamicFormItem.builder(
        this._formConfig[0].label || '',
        this._formConfig[0].name,
        ITEMS_TYPES.DROPDOWN
      ).setCssClass("full-size-item form-item-column")
        .setAttributes(this._formConfig[0].attributes)
        .setRequired(this._formConfig[0].required), this._formConfig[0]

    ));
  }

  private _widgetFormInstanceSubmitted: boolean;


  public get widgetFormInstanceSubmitted(){
    return this._widgetFormInstanceSubmitted;
  }

 public  formupdate(form){
  this.app = form.application;
}

  public set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean){
    this._widgetFormInstanceSubmitted = widgetFormInstanceSubmitted;
    this._changeDetector.markForCheck();
    this.submitCommonDocument();
  };

  public widgetFormInstance: FormGroup;

  ngOnInit() {
    this.fileTypes = this.fileService.getUploadFileTypes();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this._changeDetector.detach();
}

  widgetValidator(): boolean {
    return this.doc != null;
  }

}


